<template>
    <SlideProductsDesktop v-if="block.platform == 1" :block="block" :snapAlign="'start'" :widthRate="2"></SlideProductsDesktop>
    <SlideProductsMobile v-else :block="block" :snapAlign="'start'" :widthRate="2"></SlideProductsMobile>
</template>
<script>
import SlideProductsDesktop from '../../Desktop/Blocks/SlideProducts';
import SlideProductsMobile from '../../Mobile/Blocks/SlideProducts';
import HomeBlock from '@/models/home-block';
export default {
    components:{
        SlideProductsDesktop,
        SlideProductsMobile
    },
    props:{
        block:{
            type: HomeBlock
        }
    },
    created(){
        if(this.block.diamond){
            this.block.initDiamondData();
        }
    }
}
</script>